export default __webpack_public_path__ + "static/img_welfare_4@2x-132c58b16aeba9f237a35207453db42f.jpg";